import React, { Component } from "react";
import { connect } from "react-redux";
import {} from "../../redux/app/actions";
import {} from "../../redux/csDsp/actions";
import { openEditerAction, showMeaTimeWindowAction } from "../../redux/ui/actions";
import { addWLTrAction, addPompTrAction, updateWLTrAction, updatePompTrAction, changeWLTrSelRowAction, changePompTrSelRowAction, changeMeaSelRowAction } from "../../redux/well/actions";
import Lgd, { probLgd } from "../common/Lgd";
import Sw from "../common/Sw";
import Mea from "./Mea";
import jschardet from "jschardet";

const mapStateToProps = (state) => {
    return {
        wlTrData: state.wellReducer.wlTrData,
        pompTrData: state.wellReducer.pompTrData,
        wlTrSelRow: state.wellReducer.wlTrSelRow,
        pompTrSelRow: state.wellReducer.pompTrSelRow,
        meaTimeWindowVisible: state.uiReducer.meaTimeWindowVisible,
        meaSelRow: state.wellReducer.meaSelRow,
    };
};

class TestData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCheckbox: null,
        };
    }
    /*
     * 追加
     * @since ando 2023-8-10
     */
    addCat(type) {
        if (type == 0) {
            this.props.dispatch(addWLTrAction(this.props.wlTrData.length + 1, "", "", "", undefined, []));
        } else {
            this.props.dispatch(addPompTrAction(this.props.pompTrData.length + 1, "", "", "", undefined, []));
        }
    }
    /*
     * 行削除
     * @since ando 2024-03-27
     */
    deleteSel(type) {
        this.props.dispatch(showMeaTimeWindowAction(false));
        this.props.dispatch(changeMeaSelRowAction(null));
        this.setState({ selectedCheckbox: null });

        if (type == 0) {
            // 指定されたインデックスの行を除外して新しい wellsTrData 配列を作成する
            const updatedWLTrData = this.props.wlTrData.filter((el, i) => i != this.props.wlTrSelRow);

            const updatedWLTrDataWithNewIds = updatedWLTrData.map((el, i) => ({
                ...el,
                ID: i + 1, // 新しいidを振り直す
            }));
            // 新しい wellsTrData をセット
            this.props.dispatch(updateWLTrAction(updatedWLTrDataWithNewIds));
        } else {
            // 指定されたインデックスの行を除外して新しい wellsTrData 配列を作成する
            const updatedPompTrData = this.props.pompTrData.filter((el, i) => i != this.props.pompTrSelRow);

            const updatedPompTrDataWithNewIds = updatedPompTrData.map((el, i) => ({
                ...el,
                ID: i + 1, // 新しいidを振り直す
            }));

            // 新しい wellsTrData をセット
            this.props.dispatch(updatePompTrAction(updatedPompTrDataWithNewIds));
        }
    }

    /*
     * テーブルクリック
     * @since ando 2024-07-29
     */
    changeRow = (e, type) => {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });
        const tr = e.target.closest("tr");
        tr.classList.add("selRow");
        if (type == 0) {
            this.props.dispatch(changeWLTrSelRowAction(tr.id));
            console.log(`Row ${tr.id} clicked!`);
        } else {
            this.props.dispatch(changePompTrSelRowAction(tr.id));
            console.log(`Row ${tr.id} clicked!`);
        }
    };

    /*
     * テーブルデータ書き換え
     * @since ando 2024-07-29
     */
    changeField = (e, index, field, type) => {
        // 例えば、選択された種別を取得する処理などを追加
        const changeField = e.target.value;
        if (isNaN(changeField) && field != "name") {
            alert("数値を入力してください。");
            return;
        }
        if (type == 0) {
            const updatedWLTrData = this.props.wlTrData.map((el, i) => {
                if (i === index) {
                    return { ...el, [field]: changeField };
                }
                return el;
            });
            console.log(updatedWLTrData);
            // 新しい wellsTrData をセット
            this.props.dispatch(updateWLTrAction(updatedWLTrData));
        } else {
            const updatedPompTrData = this.props.pompTrData.map((el, i) => {
                if (i === index) {
                    return { ...el, [field]: changeField };
                }
                return el;
            });
            console.log(updatedPompTrData);
            // 新しい wellsTrData をセット
            this.props.dispatch(updatePompTrAction(updatedPompTrData));
        }
    };

    handleCheckboxClick = (index) => {
        this.setState((prevState) => ({
            selectedCheckbox: prevState.selectedCheckbox === index ? null : index,
        }));
        this.props.dispatch(showMeaTimeWindowAction(null));
        // その後の処理
        if (this.state.selectedCheckbox !== index) {
            this.props.dispatch(showMeaTimeWindowAction(true));
            this.props.dispatch(changeMeaSelRowAction(index));
        } else {
            // チェックが外された場合の処理
            this.props.dispatch(showMeaTimeWindowAction(false));
        }
    };

    /*
     * ファイルインポート
     * @since ando 2024-03-22
     */
    async fileImport(type) {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.onchange = (event) => {
            this.props.dispatch(openEditerAction(null)); //エディタを閉じる
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            const fileSizeInBytes = file.size;
            const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // バイトをMBに変換
            console.log(fileSizeInMB);

            if (fileSizeInMB > 1) {
                alert("1MB以上のファイルはアップロードできません。");
                return;
            } else {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = (event) => {
                    const arrayBuffer = event.target.result;
                    const byteArray = new Uint8Array(arrayBuffer);

                    // Uint8Array を Buffer に変換
                    const buffer = Buffer.from(byteArray);

                    // jschardet でエンコーディングを判定（Buffer を渡す）
                    const detected = jschardet.detect(buffer);
                    // エンコーディングを判定後、必要に応じて処理
                    let encoding = detected.encoding ? detected.encoding : "utf-8";
                    if (["ISO-8859-2", "ISO-8859-1", "windows-1252", "EUC-JP", "ISO-2022-JP", "CP932"].includes(encoding)) {
                        encoding = "shift-jis"; // これらの場合、Shift-JIS に切り替える
                    }
                    const decoder = new TextDecoder(encoding);
                    const contents = decoder.decode(new Uint8Array(arrayBuffer));
                    let fileContentArray = contents.split(/\r\n|\n/).filter(Boolean);
                    //テーブル内を初期化する
                    this.props.dispatch(showMeaTimeWindowAction(false));
                    if (type == 0) {
                        this.props.dispatch(updateWLTrAction([]));
                    } else {
                        this.props.dispatch(updatePompTrAction([]));
                    }

                    //カラム名をチェックする
                    let units = fileContentArray[0].split(",");
                    let name = fileContentArray[1].split(",");
                    let lat = fileContentArray[2].split(",");
                    let lon = fileContentArray[3].split(",");
                    if (units[0] != "units" || name[0] != "name" || lat[0] != "lat" || lon[0] != "lon") {
                        alert("ヘッダが異なります。units,name,lat,lonを作成してください。");
                        if (type == 0) {
                            this.props.dispatch(updateWLTrAction([]));
                        } else {
                            this.props.dispatch(updatePompTrAction([]));
                        }

                        return;
                    }
                    //単位によって、倍率を決定する。
                    let unit;
                    switch (units[1]) {
                        case "s":
                            unit = 86400;
                            break;
                        case "m":
                            unit = 1440;
                            break;
                        case "h":
                            unit = 24;
                            break;
                        case "d":
                            unit = 1;
                            break;
                        default:
                            unit = 1;
                            break;
                    }
                    // latとlonの値をオブジェクトに格納
                    // ヘッダー行を分割して取得
                    const names = fileContentArray[1].split(",");
                    const data = names.slice(1).map((name, index) => {
                        const lat = parseFloat(fileContentArray[2].split(",")[index + 1]);
                        const lon = parseFloat(fileContentArray[3].split(",")[index + 1]);
                        return { name: name, lat: lat, lon: lon, data: [] };
                    });
                    // 計測値を格納
                    for (let i = 4; i < fileContentArray.length; i++) {
                        const row = fileContentArray[i].split(",");
                        const time = parseFloat(row[0]); // 先頭の列がtime
                        row.slice(1).forEach((value, index) => {
                            const mea = value === "-" ? null : parseFloat(value);
                            if (mea != null) {
                                const modMea = mea * unit;
                                data[index].data.push({ time: time, mea: modMea });
                            }
                        });
                    }

                    console.log(data);
                    for (let i = 0; i < data.length; i++) {
                        if (type == 0) {
                            this.props.dispatch(addWLTrAction(i + 1, data[i].name, data[i].lat, data[i].lon, undefined, data[i].data));
                        } else {
                            this.props.dispatch(addPompTrAction(i + 1, data[i].name, data[i].lat, data[i].lon, undefined, data[i].data));
                        }
                    }

                    // ファイルの内容をテーブルデータに登録する
                    //カンマ区切りで3列か確認する。
                };
                //this.waiting(false);
                const a = 1;
            }
        };
        fileInput.click();
    }

    render() {
        return (
            <div>
                <Sw title="揚水試験" focusName="wells">
                    <legend> 水位データ(m)</legend>
                    <div className="l-flex">
                        <button className="sBtn" onClick={() => this.addCat(0)}>
                            追加
                        </button>
                        <button className="sBtn" onClick={() => this.deleteSel(0)}>
                            削除
                        </button>
                        <button className="sBtn" onClick={() => this.fileImport(0)}>
                            インポート
                        </button>
                    </div>
                    <div className="idoInput l-mtSSS" style={{ overflowY: "scroll" }}>
                        <table className="idoTable">
                            <thead>
                                <tr>
                                    <th className="tsS">井戸名</th>
                                    <th className="tsS">緯度</th>
                                    <th className="tsS">経度</th>
                                    <th className="tsSS">計測値</th>
                                </tr>
                            </thead>
                            <tbody ref={(ref) => (this.tbRef = ref)}>
                                {this.props.wlTrData !== undefined &&
                                    this.props.wlTrData.map((el, index) => (
                                        <tr id={index} key={index} onClick={(e) => this.changeRow(e, 0)}>
                                            <td>
                                                <input className="textTR" type="text" value={el.name} onChange={(e) => this.changeField(e, index, "name", 0)} />
                                            </td>
                                            <td>
                                                <input className="textTR" type="text" value={el.lat} onChange={(e) => this.changeField(e, index, "lat", 0)} />
                                            </td>
                                            <td>
                                                <input className="textTR" type="text" value={el.lon} onChange={(e) => this.changeField(e, index, "lon", 0)} />
                                            </td>
                                            <td className="scrCheck">
                                                <input type="checkbox" checked={this.state.selectedCheckbox === "wl" + index} onChange={() => this.handleCheckboxClick("wl" + index)} />
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <legend>　</legend>
                    <legend>
                        {" "}
                        揚水データ(m<sup>3</sup>/day)
                    </legend>
                    <div className="l-flex">
                        <button className="sBtn" onClick={() => this.addCat(1)}>
                            追加
                        </button>
                        <button className="sBtn" onClick={() => this.deleteSel(1)}>
                            削除
                        </button>
                        <button className="sBtn" onClick={() => this.fileImport(1)}>
                            インポート
                        </button>
                    </div>
                    <div className="idoInput l-mtSSS" style={{ overflowY: "scroll" }}>
                        <table className="idoTable">
                            <thead>
                                <tr>
                                    <th className="tsS">井戸名</th>
                                    <th className="tsS">緯度</th>
                                    <th className="tsS">経度</th>
                                    <th className="tsSS">計測値</th>
                                </tr>
                            </thead>
                            <tbody ref={(ref) => (this.tbRef = ref)}>
                                {this.props.pompTrData !== undefined &&
                                    this.props.pompTrData.map((el, index) => (
                                        <tr id={index} key={index} onClick={(e) => this.changeRow(e, 1)}>
                                            <td>
                                                <input className="textTR" type="text" value={el.name} onChange={(e) => this.changeField(e, index, "name", 1)} />
                                            </td>
                                            <td>
                                                <input className="textTR" type="text" value={el.lat} onChange={(e) => this.changeField(e, index, "lat", 1)} />
                                            </td>
                                            <td>
                                                <input className="textTR" type="text" value={el.lon} onChange={(e) => this.changeField(e, index, "lon", 1)} />
                                            </td>
                                            <td className="scrCheck">
                                                <input type="checkbox" checked={this.state.selectedCheckbox === "pomp" + index} onChange={() => this.handleCheckboxClick("pomp" + index)} />
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </Sw>
                {this.props.meaTimeWindowVisible ? <Mea /> : null}
            </div>
        );
    }
}

export default connect(mapStateToProps)(TestData);
